// config.tsx
export const POLLING_REFRESH_RATE = 3000;

export interface FastAPIClientConfig {
    apiBasePath: string;
    reactAppMode: string;
    authToken?: string;
    // WorkOS publishable client id (safe to expose). Lets the frontend build the
    // OAuth authorize URL itself and redirect straight to the provider, so the
    // login click never touches the (possibly cold) backend.
    workosClientId: string;
    // Frontend base URL incl. the /app path, e.g. "https://www.loa-ai.com/app".
    // MUST match the backend's REACT_APP_BASE_PATH and the redirect URI registered
    // in WorkOS — the OAuth callback is `${appBasePath}/oauth-callback`.
    appBasePath?: string;
}

const config: FastAPIClientConfig = {
    apiBasePath: process.env.REACT_APP_API_BASE_PATH!,
    reactAppMode : process.env.REACT_APP_MODE!,
    authToken: process.env.REACT_APP_AUTH_TOKEN, // if you need one, just for testing
    workosClientId: process.env.REACT_APP_WORKOS_CLIENT_ID!,
    appBasePath: process.env.REACT_APP_BASE_PATH,
};

export default config;
